import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        //dark: true,
        themes: {
            light: {
                primary: '#144835',
                secondary: '#38D200',
                lightSecondary: '#38D200',
                accent: '#525355',
                error: '#b71c1c',
                background: "#F7F7F7",
                header: "#fff",
                button: "#EEEEEE",
                universal: '#1e85f1',
                nav: '#1e85f1',
                excel: '#1D6F42',
                pdf: "#f40f02",
                text: '#FFF',
                tableHeader: '#144835',
                
            },
            dark: {
                primary: '#0473EA',
                secondary: '#144835',
                lightSecondary: '#57B732',
                accent: '#F7F7F7',
                error: '#b71c1c',
                background: "#121212",
                header: "#272727",
                button: "292929",
                universal: '#1e85f1',
                nav: '#0f1e3d',
                excel: '#1D6F42',
                pdf: "#f40f02",
                text: '#144835',
                tableHeader: '#121212',
            },
        },
    },
});
